import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Breadcrumb, Button, Col, Layout, Modal, message, Row } from 'antd';
import React from 'react';

import { IoPencil, IoReturnUpBackOutline, IoTrash } from 'react-icons/io5';
import { Link, Navigate } from 'react-router-dom';
// COMPONENTS
import Table from '../../../components/Table';
import {
  getToken,
  POST_API,
  POST_CATCH,
  titleWeb,
  verifyConfig,
} from '../../../services/api';

// CONTROLLER
import Page403 from '../../Controller/Page403';

class AdminParteContrariaList extends React.Component {
  state = {
    _navigate: false,
    _loading: true,
    // TABLE
    table_load: true,
    table_column: [],
    table_data: [],
    table_search: '',
    table_pagination: {
      current: 1,
      total: 0,
      limit: 10,
    },
    table_filter: null,
    table_sorter: null,
    table_select: [],
  };

  back = '/painel/partecontraria';

  routes = [
    { title: <Link to={this.back}>Partes Contrária</Link> },
    { title: this.props.type === 'list' ? 'Lista' : 'Lixeira' },
  ];

  componentDidMount = () => {
    titleWeb('Partes Contrária');
    this.onRenderColumns().then(() => this.onRenderData());
  };

  // LOAD DATA
  onRenderData = () => {
    this.setState({ table_load: true });
    setTimeout(async () => {
      POST_API('/opposing_part/search.php', {
        token: getToken(),
        pagination: JSON.stringify(this.state.table_pagination),
        filter: JSON.stringify(this.state.table_filter),
        sorter: JSON.stringify(this.state.table_sorter),
        search: this.state.table_search,
        type: this.props.type,
      })
        .then((rs) => rs.json())
        .then((res) => {
          if (res.return) {
            this.setState({
              table_data: res.data,
              table_pagination: {
                ...this.state.table_pagination,
                total: res.summary.QTDE,
              },
            });
          } else {
            message.error({ content: res.msg, key: 'screen' });
          }
        })
        .catch(() => POST_CATCH())
        .finally(() => this.setState({ table_load: false }));
    }, 500);
  };

  onRecover = (ID) => {
    var self = this;
    Modal.confirm({
      title: 'Restaurar senha padrão?',
      icon: <ExclamationCircleOutlined />,
      cancelText: 'Não',
      okText: 'Sim',
      onOk() {
        POST_API('/opposing_part/recpass.php', { token: getToken(), ID })
          .then((rs) => rs.json())
          .then((res) => {
            if (res.return) {
              message.success({ content: res.msg, key: 'screen' });
              self.onRenderData();
            } else {
              message.warning({ content: res.msg, key: 'screen' });
            }
          })
          .catch(() => POST_CATCH())
          .finally(() => self.setState({ _loading: false }));
      },
      onCancel() {},
    });
  };

  onAction = (ID, type, title) => {
    var self = this;
    Modal.confirm({
      title,
      icon: <ExclamationCircleOutlined />,
      cancelText: 'Não',
      okText: 'Sim',
      onOk() {
        POST_API('/opposing_part/del.php', {
          token: getToken(),
          ID,
          type,
          selected: JSON.stringify(self.state.table_select),
        })
          .then((rs) => rs.json())
          .then((res) => {
            if (res.return) {
              message.success({ content: res.msg, key: 'screen' });
              if (type === 'del-select' || type === 'rec-select')
                self.setState({ table_select: [] });
              self.onRenderData();
            } else {
              message.warning({ content: res.msg, key: 'screen' });
            }
          })
          .catch(() => {
            POST_CATCH();
          })
          .finally(() => self.setState({ _loading: false }));
      },
      onCancel() {},
    });
  };

  // FUNCTION TABLE
  onRenderColumns = async () => {
    this.setState({
      table_column: [
        {
          title: 'Cod.',
          dataIndex: 'ID',
          key: 'client.ID',
          width: 100,
          align: 'center',
          sorter: { compare: (a, b) => null },
          showSorterTooltip: false,
        },
        {
          title: 'Nome',
          dataIndex: 'NAME',
          key: 'client.NAME',
          sorter: { compare: (a, b) => null },
          showSorterTooltip: false,
        },
        {
          title: 'CPF/CNPJ',
          dataIndex: 'CPFCNPJ',
          key: 'client.CPFCNPJ',
          width: 200,
          align: 'center',
          sorter: { compare: (a, b) => null },
          showSorterTooltip: false,
        },
        {
          title: 'Ações',
          key: 'action',
          width: 100,
          render: (text, record) => (
            <Row className="table__actions" gutter={[4, 4]}>
              {this.props.type === 'list' &&
              verifyConfig(`${this.props.per}.edit`) ? (
                <Col>
                  <Link to={record.ID}>
                    <Button
                      className="table__btn table__btn_edit"
                      shape="circle"
                      size="small"
                      title="Editar"
                      type="primary"
                    >
                      <IoPencil size={14} />
                    </Button>
                  </Link>
                </Col>
              ) : null}
              {this.props.type === 'list' &&
              verifyConfig(`${this.props.per}.del`) ? (
                <Col>
                  <Button
                    className="table__btn table__btn_delete"
                    onClick={() =>
                      this.onAction(record.ID, 'del', 'Excluir registro?')
                    }
                    shape="circle"
                    size="small"
                    title="Excluir"
                    type="primary"
                  >
                    <IoTrash size={14} />
                  </Button>
                </Col>
              ) : null}
              {this.props.type === 'trash' &&
              verifyConfig(`${this.props.per}.rec`) ? (
                <Col>
                  <Button
                    className="table__btn table__btn_recover"
                    onClick={() =>
                      this.onAction(record.ID, 'rec', 'Recuperar registro?')
                    }
                    shape="circle"
                    size="small"
                    title="Recuperar"
                    type="primary"
                  >
                    <IoReturnUpBackOutline size={14} />
                  </Button>
                </Col>
              ) : null}
            </Row>
          ),
        },
      ],
    });
  };

  onTableChange = (pagination, filters, sorter, extra) => {
    this.setState({
      table_filter: filters,
      table_sorter: sorter,
    });
    this.onRenderData();
  };

  onPaginationChange = (page, size) => {
    this.setState({
      table_pagination: {
        ...this.state.table_pagination,
        current: page,
        limit: size,
      },
    });
    this.onRenderData();
  };

  onSearchChange = (e) => {
    this.setState({
      table_search: e.target.value,
    });
    this.onRenderData();
  };

  onSelect = (selectedRowKeys, selectedRows) => {
    this.setState({ table_select: selectedRows });
  };

  onChangePage = () => {
    this.setState({ table_data: [] });
    this.onRenderData();
  };

  render = () => {
    if (this.state._navigate) return <Navigate to={'/painel'} />;
    if (!verifyConfig(`${this.props.per}.${this.props.type}`))
      return <Page403 />;

    return (
      <Layout>
        <Layout.Content className={'admin-container'}>
          <Row align={'middle'} gutter={[8, 8]}>
            <Col span={18}>
              <Breadcrumb items={this.routes} />
            </Col>
            <Col
              span={6}
              style={{ display: 'flex', justifyContent: 'flex-end' }}
            >
              {this.props.type === 'list' &&
              verifyConfig(`${this.props.per}.del`) &&
              this.state.table_select.length > 0 ? (
                <Button
                  className="sys-btn-default sys-btn-small"
                  onClick={() =>
                    this.onAction(null, 'del-select', 'Excluir registros?')
                  }
                  shape="round"
                  size="small"
                  style={{ marginRight: 5 }}
                  type="default"
                >
                  Deletar Selecionados ({this.state.table_select.length})
                </Button>
              ) : null}
              {this.props.type === 'list' &&
              verifyConfig(`${this.props.per}.trash`) ? (
                <Link to={'trash'}>
                  <Button
                    className="sys-btn-default sys-btn-small"
                    onClick={this.onChangePage}
                    shape="round"
                    size="small"
                    style={{ marginRight: 5 }}
                    type="default"
                  >
                    Lixeira
                  </Button>
                </Link>
              ) : null}
              {this.props.type === 'list' &&
              verifyConfig(`${this.props.per}.add`) ? (
                <Link to={'add'}>
                  <Button
                    className="sys-btn-primary sys-btn-small"
                    shape="round"
                    size="small"
                    type="primary"
                  >
                    Novo
                  </Button>
                </Link>
              ) : null}
              {this.props.type === 'trash' &&
              verifyConfig(`${this.props.per}.rec`) &&
              this.state.table_select.length > 0 ? (
                <Button
                  className="sys-btn-default sys-btn-small"
                  onClick={() =>
                    this.onAction(null, 'rec-select', 'Recuperar registros?')
                  }
                  shape="round"
                  size="small"
                  style={{ marginRight: 5 }}
                  type="default"
                >
                  Recuperar Selecionados ({this.state.table_select.length})
                </Button>
              ) : null}
              {this.props.type === 'trash' &&
              verifyConfig(`${this.props.per}.list`) ? (
                <Link to={this.back}>
                  <Button
                    className="sys-btn-primary sys-btn-small"
                    onClick={this.onChangePage}
                    shape="round"
                    size="small"
                    type="primary"
                  >
                    Voltar
                  </Button>
                </Link>
              ) : null}
            </Col>
            <Col span={24}>
              <Table
                _columns={this.state.table_column}
                _data={this.state.table_data}
                _loading={this.state.table_load}
                _onChangePagination={this.onPaginationChange}
                _onChangeSearch={this.onSearchChange}
                _onChangeTable={this.onTableChange}
                _pagination={this.state.table_pagination}
                _rowSelection={{
                  onChange: this.onSelect,
                  getCheckboxProps: () => {},
                }}
                _search={this.state.table_search}
              />
            </Col>
          </Row>
        </Layout.Content>
      </Layout>
    );
  };
}

export default AdminParteContrariaList;
